/* src/components/pdf-page-header/pdf-page-header.component.scss */
app-pdf-page-header {
  display: block;
  width: 100%;
  background: #fff;
}
.pdf-page__header-body {
  display: flex;
  width: 100%;
  align-items: flex-end;
  justify-content: space-between;
}
.pdf-page__header-body--has-spacer {
  margin-bottom: 10mm;
}
.pdf-page__logo {
  float: right;
  display: inline-block;
  vertical-align: top;
  width: 40mm;
  height: auto;
}
.pdf-page__logo--large {
  width: 80mm;
}
/*# sourceMappingURL=pdf-page-header.component-4SF5XBD7.css.map */
